// src/pages/TransactionEntry/TransactionRow.js
import React from "react";

export default function TransactionRow({
  row,
  index,
  accounts,
  onChange,
  onFileChange,
  onRemove,
}) {
  const {
    id,
    accountId,
    date,
    expenseType,
    description,
    amountIn,
    amountOut,
    paidBy,
    comment,
    error,
  } = row;

  const hasError = !!error;

  const inputStyle = {
    width: "100%",
    padding: "4px 6px",
    fontSize: 12,
    boxSizing: "border-box",
    borderRadius: 4,
    border: hasError ? "1px solid #e53935" : "1px solid #ccc",
  };

  const numericStyle = {
    ...inputStyle,
    textAlign: "right",
  };

  return (
    <>
      <tr style={{ background: hasError ? "#ffebee" : "transparent" }}>
        {/* Sr No */}
        <td style={{ border: "1px solid #ddd", padding: "4px 6px", fontSize: 12 }}>
          {index + 1}
        </td>

        {/* Account Head */}
        <td style={{ border: "1px solid #ddd", padding: "4px 6px" }}>
          <select
            value={accountId}
            onChange={(e) => onChange(id, "accountId", e.target.value)}
            style={inputStyle}
          >
            <option value="">-- Select --</option>
            {accounts.map((acc) => (
              <option key={acc.id} value={acc.id}>
                {acc.name}
              </option>
            ))}
          </select>
        </td>

        {/* Date */}
        <td style={{ border: "1px solid #ddd", padding: "4px 6px" }}>
          <input
            type="date"
            value={date || ""}
            onChange={(e) => onChange(id, "date", e.target.value)}
            style={inputStyle}
          />
        </td>

        {/* Type */}
        <td style={{ border: "1px solid #ddd", padding: "4px 6px" }}>
          <input
            type="text"
            value={expenseType}
            onChange={(e) => onChange(id, "expenseType", e.target.value)}
            style={inputStyle}
            placeholder="Type"
          />
        </td>

        {/* Description */}
        <td style={{ border: "1px solid #ddd", padding: "4px 6px" }}>
          <input
            type="text"
            value={description}
            onChange={(e) => onChange(id, "description", e.target.value)}
            style={inputStyle}
            placeholder="Description"
          />
        </td>

        {/* Amount In */}
<td style={{ border: "1px solid #ddd", padding: "4px 6px" }}>
  <input
    type="number"
    className="no-scroll-number"
    onWheel={(e) => e.target.blur()}
    value={amountIn}
    onChange={(e) => onChange(id, "amountIn", e.target.value)}
    style={numericStyle}
    placeholder="0.00"
    step="0.01"
  />
</td>

{/* Amount Out */}
<td style={{ border: "1px solid #ddd", padding: "4px 6px" }}>
  <input
    type="number"
    className="no-scroll-number"
    onWheel={(e) => e.target.blur()}
    value={amountOut}
    onChange={(e) => onChange(id, "amountOut", e.target.value)}
    style={numericStyle}
    placeholder="0.00"
    step="0.01"
  />
</td>


        {/* Paid By */}
        <td style={{ border: "1px solid #ddd", padding: "4px 6px" }}>
          <input
            type="text"
            value={paidBy}
            onChange={(e) => onChange(id, "paidBy", e.target.value)}
            style={inputStyle}
            placeholder="Paid By"
          />
        </td>

        {/* Comment */}
        <td style={{ border: "1px solid #ddd", padding: "4px 6px" }}>
          <input
            type="text"
            value={comment}
            onChange={(e) => onChange(id, "comment", e.target.value)}
            style={inputStyle}
            placeholder="Comment"
          />
        </td>

        {/* Proof File */}
        <td style={{ border: "1px solid #ddd", padding: "4px 6px" }}>
          <input
            type="file"
            onChange={(e) => onFileChange(id, e.target.files?.[0] || null)}
            style={{ fontSize: 11 }}
          />
        </td>

        {/* Actions */}
        <td
          style={{
            border: "1px solid #ddd",
            padding: "4px 6px",
            textAlign: "center",
          }}
        >
          <button
            type="button"
            onClick={() => onRemove(id)}
            style={{
              background: "#e53935",
              color: "#fff",
              border: "none",
              borderRadius: 4,
              padding: "3px 8px",
              fontSize: 11,
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        </td>
      </tr>

      {hasError && (
        <tr>
          <td
            colSpan={11}
            style={{
              border: "1px solid #ffcdd2",
              padding: "4px 8px",
              fontSize: 11,
              color: "#c62828",
              background: "#ffebee",
            }}
          >
            {error}
          </td>
        </tr>
      )}
    </>
  );
}
